import { createContext, useContext } from "react";

const FileTokenContext = createContext({});

export const FileTokenContextProvider = FileTokenContext.Provider;
export const FileTokenContextConsumer = FileTokenContext.Consumer;

export const useFileTokenContext = () => useContext(FileTokenContext);

export default FileTokenContext;
